<template>
  <div v-if="quotes" class="dashboard-table-wrapper">
    <div class="pagination-container" style="height: auto !important">
      <paginate
        v-model="pagination.page"
        :page-count="pagination.page_count"
        :click-handler="paginate"
        :hide-prev-next="true"
        :prev-text="'<'"
        :next-text="'>'"
        :prev-link-class="'pagination-item pagination-prev'"
        :next-link-class="'pagination-item pagination-prev'"
        :page-link-class="'pagination-item'"
        :active-class="'pagination-item-active'"
        :container-class="'pagination'">
      </paginate>
    </div>

    <div>
      <div v-if="selectedQuotes.length > 0">
        <a style="cursor:pointer; color: #b50a78;" @click="massDestroy()">Delete selected</a>
      </div>
      <table id="quotes-table" class="dashboard-table">
        <thead>
        <tr>
          <th>
            <input id="toggleCheckboxesIndex" type="checkbox" @change="toggleCheckboxes($event)">
          </th>
          <th @click="sort('id')">
            ID
            <i v-if="currentSort === 'id' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'id' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <th @click="sort('user.name')">
            Name
            <i v-if="currentSort === 'user.name' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'user.name' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <th @click="sort('user.email')">
            Email
            <i v-if="currentSort === 'user.email' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'user.email' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <th @click="sort('user.company_name')">
            Company name
            <i v-if="currentSort === 'user.company_name' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'user.company_name' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <th @click="sort('user.contact_phone')">
            Contact phone
            <i v-if="currentSort === 'user.contact_phone' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'user.contact_phone' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <th @click="sort('office_address')">
            Office address
            <i v-if="currentSort === 'office_address' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'office_address' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <th @click="sort('office_postcode')">
            Office postcode
            <i v-if="currentSort === 'office_postcode' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'office_postcode' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <th>Preferences</th>
          <th @click="sort('updated_at')">
            Updated at
            <i v-if="currentSort === 'updated_at' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'updated_at' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <th @click="sort('created_at')">
            Created at
            <i v-if="currentSort === 'created_at' && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === 'created_at' && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
          <td></td>
          <td></td>
          <td></td>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <!-- Temporarily Removed, seems to be a duplicate link to /proposal/calculations -->
          <!-- <th>&nbsp;</th>-->
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="quote in quotes">
          <td>
            <input id="IndexQuoteList" type="checkbox" v-model="checkboxes[quote.id]">
          </td>
          <td>{{ quote ? quote.id : null }}</td>
          <td>{{ quote.user ? quote.user.name : null }}</td>
          <td>{{ quote.user ? quote.user.email : null }}</td>
          <td>{{ quote.user ? quote.user.company_name : null }}</td>
          <td>{{ quote.user ? quote.user.contact_phone : null }}</td>
          <td>{{ quote.office_address }}</td>
          <td class="cell-postcode">{{ quote.office_postcode }}</td>
          <td class="value">
            <span v-if="quote.user.preferences" v-html="quote.user.preferences.preferences_email ? '- email <br>' : null "></span>
            <span v-if="quote.user.preferences" v-html="quote.user.preferences.preferences_mail ? '- mail <br>' : null "></span>
            <span v-if="quote.user.preferences" v-html="quote.user.preferences.preferences_phone ? '- phone <br>' : null "></span>
            <span v-if="quote.user.preferences" v-html="quote.user.preferences.preferences_sms ? '- sms <br>' : null "></span>
          </td>
          <td>{{ quote.updated_at }}</td>
          <td>{{ quote.created_at }}</td>
          <td>
            <router-link v-if="quote" tag="a" :to="{name: 'proposal.calculations', params: {id: quote.uniqid}}">Proposal calculations</router-link>
          </td>
          <td>
            <router-link v-if="quote" tag="a" :to="{name: 'proposal.summary', params: {id: quote.uniqid}}" target="_blank">Proposal Summary</router-link>
          </td>
          <td>
            <a href="#" @click="loadQuote(quote.id, 1)">Step1</a>
          </td>
          <td>
            <a href="#" @click="loadQuote(quote.id, 2)" v-if="quote.step2">Step2</a>
            <span style="color:grey;" v-if="!quote.step2">Step2</span>
          </td>
          <td>
            <a href="#" @click="loadQuote(quote.id, 3)" v-if="quote.step3">Step3</a>
            <span style="color:grey;" v-if="!quote.step3">Step3</span>
          </td>
          <!-- Temporarily Removed, seems to be a duplicate link to /proposal/calculations -->
          <!--
          <td>
            <a v-if="quote" :href="base_url + '/proposal/calculations/' + quote.uniqid" target="_blank">Excel</a>
          </td>
          -->
          <td>
            <router-link tag="a" :to="{name: 'results.index', params: {quote_id: quote.uniqid}}">Results</router-link>
          </td>
          <td>
            <router-link v-if="quote.order" tag="a" :to="{name: 'orders.index', params: {id: quote.order.uniqid}}">Order</router-link>
          </td>
          <td>
            <a style="cursor:pointer; color: #b50a78;" @click="destroy(quote.id)">Delete</a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  export default {
    created() {
      this.load()
    },
    data() {
      return {
        quotes: [],
        currentSort: 'id',
        currentSortDir: 'desc',
        checkboxes: [],
        selectedQuotes: [],

        pagination: {
          page: 1,
          rows_per_page: 50,
          page_count: 1
        }
      }
    },
    watch: {
      checkboxes: {
        handler(value) {
          this.selectedQuotes = []
          _.each(this.checkboxes, (value, quote_id) => {
            if (value === true) {
              this.selectedQuotes.push(quote_id)
            }
          })
        },
        deep: true
      }
    },
    computed: {
      base_url() {
        return process.env.BASE_URL
      },
      // sortedQuotes: function () {
      //   return this.quotes.sort((a, b) => {
      //     let modifier = 1;
      //     if (this.currentSortDir === 'desc') modifier = -1;
      //     var index = this.currentSort.split('.')
      //     if (index.length == 1) {
      //       if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
      //       if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
      //     } else {
      //       if (a[index[0]][index[1]] < b[index[0]][index[1]]) return -1 * modifier;
      //       if (a[index[0]][index[1]] > b[index[0]][index[1]]) return 1 * modifier;
      //     }
      //     return 0;
      //   });
      // },
    },
    methods: {
      paginate() {
        this.load()
        this.$router.push({query: {...this.$route.query, page: this.pagination.page}})
      },

      loadQuote(quote_id, step) {
        this.$store.dispatch('QuoteForm/loadQuoteInStep', {quote_id, step}).then(() => {
          this.$router.push({name: 'quotes.create', query: {dont_reset: true, scroll_bottom: true}})
        })
      },
      load(data) {
        this.axios.get('/quotes?page=' + this.pagination.page + '&pagesize=' + this.pagination.rows_per_page + '&sort=' + this.currentSort + '&sortdir=' + this.currentSortDir).then(response => {
          _.each(response.data.data, q => {
            this.checkboxes[q.id] = false
          })

          this.pagination.page_count = response.data.last_page
          this.quotes = _.reverse(response.data.data)
        })

      },
      sort: function (s) {
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.currentSort = s;

        this.load()
      },
      toggleCheckboxes($event) {
        let checked = $event.target.checked
        this.selectedQuotes = []
        _.each(this.checkboxes, (v, k) => {
          this.checkboxes[k] = checked
          if (checked) {
            this.selectedQuotes.push(k)
          }
        })
        this.$forceUpdate()
      },
      massDestroy() {
        if (!confirm("Are you sure?")) {
          return;
        }
        let quotes = _.map(this.checkboxes, (q, id) => {
          if (q === true) {
            return id
          }
        })

        this.axios.post('/quotes/massDelete', {quotes}).then(response => {
          this.load()
          this.selectedQuotes = []
        })
      },
      destroy(id) {
        if (!confirm("Are you sure?")) {
          return;
        }

        this.axios.delete('/quotes/' + id).then(response => {
          let index = _.findIndex(this.quotes, q => q.id === id)
          this.quotes.splice(index, 1)
          delete this.checkboxes[id]
        })
      }
    },
  }
</script>
<style lang="scss">
  .cell-postcode {
    max-width: 100px;
    white-space: normal !important;
  }

  .pagination-container {
    margin-left: 17px;
  }

  .pagination-item {
    color: black;
    display: block;
    border: 1px solid #ccc;
    float: left;
    padding: 8px 16px;
    margin: 10px 2px;
    text-decoration: none;
  }

  .pagination-item-active {
    font-weight: 900;

    a {
      color: #b50a78 !important;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/Quotes/Index.vue